
<template>
  <div class="agreement-wrap">
    <div class="agreement-content">
      <div class="agreement-back"></div>
      <div class="agreement-stop-heat">
        <div class="agreement-text">
          <div class="agreement-text-box">
            <div
              style="
                text-align: center;
                font-size: 0.18rem;
                font-weight: bold;
                margin-bottom: 0.2rem;
                opacity: 1;
                color: #333333;
              "
            >
            暂停供热协议
              <div style="font-size: 0.14rem; font-weight: 400">（2026版）</div>
            </div>
            <div class="agreement-text-content">
              <p style="text-indent: 0">
                甲方:（供热单位）<span style="font-weight: 700">承德市双滦区兴业热力有限公司</span
                ><br />
                乙方:（申请人）:<span>&nbsp;&nbsp;{{ owner_name }}&nbsp;&nbsp;</span><br />
              </p>

              <p>
                乙方位于<span style="border-bottom: 1px solid #333; font-weight: 700"
                  >&nbsp;&nbsp;{{ address }}&nbsp;&nbsp;</span
                >的房屋（卡号：<span style="border-bottom: 1px solid #333; font-weight: 700"
                  >&nbsp;&nbsp;{{ cardCode }}&nbsp;&nbsp;</span
                >）
              </p>
              <p>
                因乙方房屋闲置不用，特向甲方申请2026-2027年采暖季暂停供热。为防止私开或误开阀门，导致跑冒滴漏或形成事实用热等情况发生，避免矛盾纠纷，根据《中华人民共和国民法典》、《河北省供热用热办法》、《承德市城市供热条例》和市住建局、城管局《关于规范暂停供热管理的通知》精神，甲、乙方同意签订如下协议：
              </p>

              <p style="font-weight: 700">第一条 乙方首次申请暂停供热应当符合下列条件</p>
              <p>
                1、停热房屋供热采暖系统应当具备<span style="font-weight: 700">独立控制</span>条件；
              </p>
              <p>
                2、停热房屋与用热房屋管路<span style="font-weight: 700">不交叉</span>、房屋之间<span style="font-weight: 700">不相通</span>（采用硬隔断墙相隔）；
              </p>
              <p>
                3、<span style="font-weight: 700">不影响</span
                >共用供热设施安全运行和<span style="font-weight: 700">其他热用户正常用热；</span>
              </p>
              <p>
                4、暂停供热为一个完整采暖期；
              </p>
              <p>
                5、非居民用户应按政策规定缴纳停热费；
              </p>
              <p style="font-weight: 700">第二条 乙方申请连续停热的应当符合下列条件</p>
              <p>
                1、诚实守信，不存在供用热矛盾纠纷；
              </p>
              <p>
                2、不拖欠甲方相关费用；
              </p>
              <p>
                3、不影响其他热用户正常用热；
              </p>
              <p>
                4、没有或已修复不良信用记录。
              </p>

              <p style="font-weight: 700">第三条 双方权利与义务</p>
              <p>
                1、甲、乙方在9月30日前首次签订本协议的，停热施工费用由甲方承担。否则，施工费用由乙方承担。自签订本协议之日起，如甲方在<span style="font-weight: 700">10日内</span>没有联系乙方，乙方应主动拨打<span style="font-weight: 700">966011</span>电话咨询。
              </p>
              <p>
                2、甲方施工时，要求乙方到场配合的，乙方应当<span style="font-weight: 700">予以配合</span>。是否完成停热施工，以甲方完成停热施工的<span style="font-weight: 700">录像</span>为准。乙方不具备停热条件的，本协议自动解除。乙方接到通知后，应当交纳热费。
              </p>
              <p>
                3、甲方<span style="font-weight: 700">完成停热施工后</span>，乙方应<span style="font-weight: 700">自行检查室内总控制阀门</span>，室内没有总进、回水阀门的应<span style="font-weight: 700">自行安装</span>，以防室外被他人误开。然后自行放净暖气片或地暖管内的供热循环水，采取<span style="font-weight: 700">防冻、防漏</span>措施。
              </p>
              <p>
                4、<span style="font-weight: 700">停热期间</span>，若乙方需要更换室内总进、回水阀门，应提前告知甲方再次检查室外<span style="font-weight: 700">总控制阀门</span>是否安全可靠。因乙方原因，导致跑水漏水或冻坏采暖设施，给自身或他人造成经济损失的，均由乙方负责。
              </p>
              <p>
                5、<span style="font-weight: 700">供热期间</span>，乙方有义务确保停热房屋<span style="font-weight: 700">始终处于停热状态</span>。若被甲方发现乙方事实用热的，应及时处理。乙方拒绝接受处理的，甲方可拆除供热设施并在收费系统标注<span style="font-weight: 700">不良信用记录</span>。
              </p>
              <p>
                6、因乙方阁楼或地下室停热导致主体房屋室温不达标的，甲方不承担责任。
              </p>
              <p>
                7、乙方需要恢复供热的，应<span style="font-weight: 700">主动修复</span>停热期间的不良信用记录，并按政策规定缴纳热费。需要连续停热的，应按政策规定缴纳停热费。
              </p>
              

              <p style="font-weight: 700">第四条 违约责任</p>
              <p>
                1、乙方故意设置障碍或包括但不限于不予配合、预留电话错误等导致甲方无法施工的，此协议终止，乙方应<span style="font-weight: 700">全额交纳热费</span>。
              </p>
              <p>
                2、因乙方室内没有总控制阀门或阀门控制失效，形成事实供热的，乙方应<span style="font-weight: 700">全额补缴热费</span>。
              </p>
              <p>
                3、乙方拖欠甲方热费和停热费的，从逾期之日起，<span style="font-weight: 700">按日1‰计收违约金</span>（最高不超过本金的30%）并承担一切不利后果。
              </p>
              <p>
                4、<span style="font-weight: 700">供热期间</span>，发现乙方停热<span style="font-weight: 700">影响他人正常用热的</span>，应当<span style="font-weight: 700">恢复供热</span>。热费按实际供热<span style="font-weight: 700">天数计算</span>（正常居住故意蹭热的，须<span style="font-weight: 700">全额补交</span>热费）。
              </p>
              <p>
                5、乙方停热后擅自开启供热阀门或接通供热管道<span style="font-weight: 700">窃取热能</span>的，应按热费总额的<span style="font-weight: 700">1-2倍赔偿</span>甲方经济损失并按热费总额的30%支付违约金。乙方违反《治安管理处罚法》的，由公安机关依法处理；构成犯罪的，依法追究<span style="font-weight: 700">刑事责任</span>。
              </p>
              <p>
                6、因乙方违约<span style="font-weight: 700">被起诉</span>，除依法赔偿甲方经济损失和相应的违约责任外，还应承担甲方因此支出的<span style="font-weight: 700">全部费用</span>，包括但不限于诉讼费、律师费、交通费、保全费、执行费等。
              </p>
              <p style="font-weight: 700">第五条 其他约定</p>
              <p>
                1、本协议<span style="font-weight: 700">有效期一年</span>。在收费政策不变的情况下，乙方如符合本协议第二条约定，有效期可<span style="font-weight: 700">自动延续</span>；若乙方不符合连续停热条件或已恢复供热的，本协议<span style="font-weight: 700">自动解除</span>。若收费(包括停热费)<span style="font-weight: 700">政策调整</span>，则按新政策执行。
              </p>
              <p>
                2、<span style="font-weight: 700">本协议</span>一式二份，甲、乙方各持一份，本协议自双方签字盖章（或网签）后生效。在履行本协议期间，若发生争议，由双方协商解决，协商不成的，任何一方均可向双滦区人民法院提起诉讼。
              </p>
              <p>
                3、乙方对本协议条款<span style="font-weight: 700">如有异议</span>，可在<span style="font-weight: 700">7日内提出</span>，经甲、乙方协商一致后另行签订<span style="font-weight: 700">补充协议</span
                >，补充协议与本协议具有同等法律效力。
              </p>
              <p>
                4、甲方为乙方缴纳家庭“漏水险”保费提供<span style="font-weight: 700">便捷服务</span
                  >，线上、线下均可办理。因乙方未缴纳<span style="font-weight: 700">“漏水险”保费</span>，一旦楼内共用和室内自用供热设施发生跑水漏水的，由乙方<span style="font-weight: 700">自行承担</span>责任。
              </p>
            </div>
          </div>
          <div class="agreement-check">
            <div v-if="checkedFlag" @click="checkedFlag = false">
              <img
                src="../../../assets/image/selected-icon.png"
                style="width: 0.16rem; height: 0.16rem; margin-top: 0.03rem"
                alt
              />
              <span class="agreement-content">我已阅读并同意</span>
            </div>
            <div v-else @click="checkedFlag = true">
              <img
                src="../../../assets/image/outcheck-icon.png"
                alt
                style="width: 0.16rem; height: 0.16rem; margin-top: 0.03rem"
              />
              <span class="agreement-content">我已阅读并同意</span>
            </div>
          </div>
        </div>
        <div :class="checkedFlag ? 'agreement-btn-check' : 'agreement-btn'">
          <el-button type="primary" :disabled="enterDisabled" @click="gotoUserInfluence"
            >继续</el-button
          >
        </div>
        <div class="agreement-btn">
          <el-button
            type="primary"
            style="
              background: rgba(0, 123, 131, 0.1);
              border: 1px solid rgba(0, 123, 131, 1);
              color: #007b83;
              opacity: 1;
            "
            @click="handleCancelClick"
            >取消</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      cardCode: this.$route.query.cardCode,
      owner_name: this.$route.query.owner_name,
      address: this.$route.query.address,
      areaId: JSON.parse(this.$route.query.areaId),
      allArea: this.$route.query.allArea,
      showStopHeat: true,
      checkedFlag: false,
      enterDisabled: false,
    };
  },
  methods: {
    // 停热协议按钮
    gotoUserInfluence() {
      if (!this.checkedFlag) return;
      this.getContinueStopSuccessInfo();
    },
    handleCancelClick() {
      this.$router.replace({
        name: 'index',
      });
    },
    async getContinueStopSuccessInfo() {
      this.enterDisabled = true;
      const res = await this.$http.put(`${this.$url.globalurl}/wxContinueStop/0`, {
        areaId: this.areaId,
        area: this.allArea,
      });
      if (res.code === 200) {
        if (res.result == true) {
          this.$router.replace({
            name: 'continueStopSuccess',
          });
        } else {
          this.$router.replace({
            name: 'searchHint',
            query: {
              continueStopFail: true,
            },
          });
        }
      } else {
        this.$router.push({
          name: 'searchHint',
          query: {
            continueStopFail: true,
          },
        });
      }

      this.enterDisabled = false;
    },
  },
  mounted() {
    // console.log(this.areaId);
    document.title = '在线续停须知';
  },
};
</script>
<style lang='scss' scoped>
.agreement-wrap {
  height: 100%;
  overflow: auto;
  margin: 0;
}
.agreement-content {
  height: calc(100vh + 1px);
  position: relative;
  top: 0;
}
p {
  text-indent: 2em;
}
.agreement-back {
  position: absolute;
  width: 100%;
  height: 0px;
  top: -0.2rem;
  padding-bottom: 25%;
  background-image: url(../../../assets/image/bgtop.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.agreement-text {
  position: relative;
  margin: 0.2rem;
  background: #fff;
  padding: 0.2rem 0rem 0.1rem 0.2rem;
  box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.15);
  border-radius: 0.2rem;
}
.agreement-text-box {
  height: 70vh;
  line-height: 0.25rem;
}
.agreement-text-box > div {
  color: rgba(51, 51, 51, 1);
  opacity: 0.8;
}
.agreement-text-content {
  height: 59vh;
  overflow: auto;
  padding-right: 0.1rem;
}
.agreement-stop-heat {
  padding-bottom: 0.2rem;
}
.line {
  font-weight: 700;
  display: inline-block;
  border-bottom: 1px solid #333;
}
.agreement-text-box .agreement-check-text {
  width: 2.7rem;
  color: rgba(51, 51, 51, 1);
  margin-left: 0.1rem;
  font-size: 0.12rem;
  opacity: 0.8;
}
.agreement-check {
  display: flex;
  margin-top: 0.2rem;
  line-height: 0.2rem;
}
.agreement-text-box .agreement-outcheck-text {
  width: 2.7rem;
  margin-left: 0.1rem;
  font-size: 0.12rem;
  color: #007b83;
}
.agreement-check > div {
  display: flex;
  height: 0.2rem;
  vertical-align: middle;
}
.agreement-content {
  display: inline-block;
  height: 100%;
  // margin-left: 0.1rem;
}
.agreement-btn,
.agreement-btn-check {
  text-align: center;
  margin-top: 0.2rem;
}
.agreement-btn:last-child {
  margin-bottom: 0.2rem;
}
.agreement-btn-check button {
  width: 2.7rem;
  padding: 4%;
  border: 1px solid rgba(0, 123, 131, 1);
  background: rgba(0, 123, 131, 1);
}
.agreement-wrap .el-button--primary:focus,
.el-button--primary:hover {
  border: 1px solid rgba(0, 123, 131, 1);
  background: rgba(0, 123, 131, 1) !important;
}
.agreement-btn button {
  width: 2.7rem;
  padding: 4%;
  border: 1px solid rgba(0, 123, 131, 1);
  background: rgba(0, 123, 131, 1);
  opacity: 0.5;
}
.agreement-text-content::-webkit-scrollbar {
  width: 0.05rem;
  height: 0.05rem;
}
.agreement-text-content::-webkit-scrollbar-corner {
  background: #909399;
}
.agreement-text-content::-webkit-scrollbar-thumb {
  background: #909399;
}
.agreement-text-content::-webkit-scrollbar-track {
  background: #eceef1;
}
</style>